import { Text } from "@radix-ui/themes";

interface HeadingBlockProps {
  level: 1 | 2 | 3;
  text: string;
}

export function HeadingBlock({ level, text }: HeadingBlockProps) {
  if (level === 1) {
    return (
      <Text
        as="p"
        size="7"
        weight="bold"
        className="tracking-tight text-puntt-neutral-gray-12"
        data-testid="heading-block-1"
      >
        {text}
      </Text>
    );
  }

  if (level === 2) {
    return (
      <Text
        as="p"
        size="4"
        weight="bold"
        className="tracking-tight text-puntt-neutral-gray-12"
        data-testid="heading-block-2"
      >
        {text}
      </Text>
    );
  }

  return (
    <Text
      as="p"
      size="2"
      weight="bold"
      className="uppercase tracking-wide text-puntt-neutral-gray-11"
      data-testid="heading-block-3"
    >
      {text}
    </Text>
  );
}
